import React, { FC } from 'react';
import { useTheme } from '@material-ui/core';
import { DiscoveryItem } from './apis/model-results/models';
import { useStyles } from './styles/globals';

export interface DiscoveryItemCardProps {
  item: DiscoveryItem;
}

const DiscoveryItemCard: FC<DiscoveryItemCardProps> = ({
  item: { category, question, covered, response },
}) => {
  const theme = useTheme();
  const classes = useStyles();

  return (
    <span className={classes.appText}>
      {covered ? '✅' : '❓'} <b>{category}:</b> {question}
      {response && (
        <>
          <br />
          <span className={classes.appText} style={{ color: theme.palette.text.secondary }}>
            {response}
          </span>
        </>
      )}
    </span>
  );
};

export default DiscoveryItemCard;
